import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface CompanyAdmin {
  id: string
  name: string
  isPrimaryAdmin: string
}

export const getAvailableEmployees = (): Promise<any> => {
  return adminHttpClient.get('/AdminDashboard/CompanySettings/CompanyAdmins/AvailableEmployees')
}

export const getCompanyAdmins = (): Promise<any> => {
  return adminHttpClient.get('/AdminDashboard/CompanySettings/CompanyAdmins')
}

export default getCompanyAdmins
